import { formatResultsDate } from '../../../functions/functions';

/**
 * Header reutilizable para las tarjetas deportivas.
 *
 * @param {Object} data - Información del evento (liga, fecha, estado, clase).
 * @param {string} prefixClass - Prefijo CSS para el tipo de tarjeta (ej: "card-tenis", "card-global", "card-f1").
 */
export default function HeaderSponsored({ data, prefixClass = '', indexJson }) {
  const {
    liga = '',
    period_title = '',
    utc_date,
    class: gameClass = '',
    sport = '',
    phase = '',
    game_name
  } = data;

  // Mapeo de clase de estado visual
  const statusClassMap = {
    'clarosports-finished-game': 'statusFinalizado',
    'clarosports-error-game': 'statusError',
    'clarosports-in-progress-game': 'statusLive',
    'clarosports-next-game': 'statusProximo',
  };

  // Clase de estado correspondiente
  const statusClass = statusClassMap[gameClass] || '';
  // Determina si el partido es "próximo"
  const isNext = gameClass === "clarosports-next-game";
  const isLive = gameClass === "clarosports-in-progress-game";
  const isTennis = sport === 'TNS';
  const ligaTitle = liga; //(liga?.length === 0) ? phase : liga;
  const phaseTitle = phase;

  const formatNextGameDate = (utcDate) => {
    if (!utcDate) return formatResultsDate(utcDate);
    const date = new Date(utcDate);
    const localTime = date.toLocaleTimeString('es-ES', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    });
    const month = date.toLocaleDateString('es-ES', { month: 'short' }).slice(0, 3);
    const day = date.getDate();
    return `${month} ${day} | ${localTime}`;
  };

  const renderStatus = () => {
    const truncate = (text, maxLength = 18) => {
      if (!text) return '';
      return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };

    if (isNext) {
      return formatNextGameDate(utc_date);
    }

    if (isLive) {
      return (
        <div className='container-live'>
          <span className='live'>EN VIVO</span>
          {!isTennis && ` ${truncate(period_title)}`}
        </div>
      );
    }
    
    const period = truncate(String(period_title).toUpperCase());
    return prefixClass === 'card-f1' ? `${period} - ${game_name}` : period;
  };

  return (
    <div className={`${prefixClass}__header`}>
      <p className={`${prefixClass}__header-liga`}>{ligaTitle ? ligaTitle : ""}</p>
      <p className={`${prefixClass}__header-phase`}>{phaseTitle ? phaseTitle : ""}</p>
      <div className={`${prefixClass}__header-status ${statusClass}`}>
        {renderStatus()}
      </div>
    </div>
  );
}